import { render, staticRenderFns } from "./PersonaComponent.vue?vue&type=template&id=587375f4"
import script from "./PersonaComponent.vue?vue&type=script&lang=js"
export * from "./PersonaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports